import Cookie from '../../shared/menuLogic/cookie';
import AlltIdAuthorizer from '../../shared/alltid';

const auth = new AlltIdAuthorizer();
const logoutUser = () => {
  const returnUrl = window.location.pathname.startsWith('/mina-sidor') ? 'https://www.elle.se/' : window.location.href;
  auth.logout(encodeURIComponent(returnUrl));
};

const init = async () => {
  document.addEventListener('loggedIn', function () {
    document.querySelector('.login').style.display = 'none';
    document.querySelector('.my-page').style.display = 'flex';
    document.querySelector('.c-menu__member__wrapper').style.display = 'block';
    document.querySelector('.settings').href = `${process.env.ALLTID_URL}/mina-sidor?return=${encodeURIComponent(
      window.location.href
    )}`;
    // get alltIdData from cookie
    var alltIdData = Cookie.get('alltIdData');
    if (alltIdData) {
      const memberFirstName = JSON.parse(alltIdData).name ? JSON.parse(alltIdData).name : '';
      const welcomeHeader = document.getElementById('elle-member-welcome');
      if (welcomeHeader) {
        welcomeHeader.innerHTML = `Hej ${memberFirstName} och välkommen till ELLE Member`;
      }
    }
  });

  document.addEventListener('notLoggedIn', function () {
    document.querySelector('.login').href = `${process.env.ALLTID_URL}?return=${encodeURIComponent(
      window.location.href
    )}`;
    document.querySelector('.login').style.display = 'flex';
    document.querySelector('.my-page').style.display = 'none';
    document.querySelector('.c-menu__member__wrapper').style.display = 'none';
  });

  document.querySelector('.logout').addEventListener('click', () => logoutUser());
};

export default {
  init,
};
